import * as React from 'react';
import Button from '@mui/material/Button';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import ShoppingCartCheckoutSharpIcon from '@mui/icons-material/ShoppingCartCheckoutSharp';
import PeopleIcon from '@mui/icons-material/People';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import WindowIcon from '@mui/icons-material/Window';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HandymanIcon from '@mui/icons-material/Handyman';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { Box, ImageList, ImageListItem, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTrackedUser } from './UserState';
import { useTheme } from '@emotion/react';
import DocumentTitle from '../Utils/DocumentTitle';

const button_sx = { height: '100%', display: 'block', padding: 4, fontSize: 26 }

export default function Home() {
    DocumentTitle(`Home`)
    const theme = useTheme();
    const [my_user,] = useTrackedUser();
    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
    const navigate = useNavigate();
    const isSmDown = useMediaQuery(theme.breakpoints.down('md'));

    React.useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <React.Fragment>
            <Box margin='auto' sx={{ width: '100%' }}>
                <h3>Actions</h3>
                <ImageList variant="standard" cols={parseInt((windowWidth - (isSmDown ? 0 : 255)) / 300)} gap={8}>
                    {my_user?.client?.has_rental &&
                        <ImageListItem key={`reserve`}>
                            <Button sx={button_sx} variant='contained' onClick={() => navigate('/Reserve')}>
                                <span><AccessTimeFilledIcon /></span>
                                <br />
                                <span>Make Reservations</span>
                            </Button>
                        </ImageListItem>
                    }
                    {my_user?.client?.has_rental &&
                        <ImageListItem key={`contracts`}>
                            <Button sx={button_sx} color="success" variant='contained' onClick={() => navigate('/Contracts')}>
                                <span><ShoppingCartCheckoutSharpIcon /></span>
                                <br />
                                <span>View Contracts</span>
                            </Button>
                        </ImageListItem>
                    }
                    {my_user?.client?.has_service &&
                        <ImageListItem key={`newServiceOrder`}>
                            <Button sx={button_sx} variant='contained' onClick={() => navigate('/NewServiceOrder')}>
                                <span><AddCircleIcon /></span>
                                <br />
                                <span>Create Service Order</span>
                            </Button>
                        </ImageListItem>
                    }
                    {my_user?.client?.has_service &&
                        <ImageListItem key={`serviceorders`}>
                            <Button sx={button_sx} color="success" variant='contained' onClick={() => navigate('/ServiceOrders')}>
                                <span><HandymanIcon /></span>
                                <br />
                                <span>View Service Orders</span>
                            </Button>
                        </ImageListItem>
                    }
                </ImageList>
                <h3>Configurations</h3>
                <ImageList variant="standard" cols={parseInt((windowWidth - 255) / 250)} gap={8}>
                    {(my_user?.root_admin || my_user?.permissions_user_admin) &&
                        <ImageListItem key={`users`}>
                            <Button sx={button_sx} color="brandcolor" variant='contained' onClick={() => navigate('/Users')}>
                                <span><AccountCircleIcon /></span>
                                <br />
                                <span>Users</span>
                            </Button>
                        </ImageListItem>
                    }
                    <ImageListItem key={`customers`}>
                        <Button sx={button_sx} color="brandcolor" variant='contained' onClick={() => navigate('/Customers')}>
                            <span><PeopleIcon /></span>
                            <br />
                            <span>Customers</span>
                        </Button>
                    </ImageListItem>
                    {(my_user?.root_admin || my_user?.permissions_config_admin) &&
                        <ImageListItem key={`locations`}>
                            <Button sx={button_sx} color="brandcolor" variant='contained' onClick={() => navigate('/Locations')}>
                                <span><LocationOnIcon /></span>
                                <br />
                                <span>Locations</span>
                            </Button>
                        </ImageListItem>
                    }
                    {(my_user?.root_admin || my_user?.permissions_reports_user) &&
                        <ImageListItem key={`reports`}>
                            <Button sx={button_sx} color="brandcolor" variant='contained' onClick={() => navigate('/Reports')}>
                                <span><AssessmentIcon /></span>
                                <br />
                                <span>Reports</span>
                            </Button>
                        </ImageListItem>
                    }
                    {my_user?.client?.has_rental &&
                        <ImageListItem key={`configurations`}>
                            <Button sx={button_sx} color="brandcolor" variant='contained' onClick={() => navigate('/RentalConfigs')}>
                                <span><SettingsIcon /></span>
                                <br />
                                <span>Rental Configurations</span>
                            </Button>
                        </ImageListItem>
                    }
                    {my_user?.client?.has_rental &&
                        <ImageListItem key={`items`}>
                            <Button sx={button_sx} color="brandcolor" variant='contained' onClick={() => navigate('/RentalItems')}>
                                <span><WindowIcon /></span>
                                <br />
                                <span>Rental Items</span>
                            </Button>
                        </ImageListItem>
                    }
                </ImageList>
            </Box>
        </React.Fragment>
    );
}